import axiosInstance from "../../../../api/axiosConfig";

export const addSampleProduct = (data: any) => {
  return axiosInstance.post("/admin/sample-products", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getSampleProduct = (id: string) => {
  return axiosInstance.get(`/admin/sample-products/${id}`);
};

export const updateSampleProduct = (id: string, data: any) => {
  return axiosInstance.patch(`/admin/sample-products/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
